//import React from 'react';


//export default function About() {
  //return (
    
   //   <div className='aboutme'>
    //    <h1> ABOUT ME </h1>
      //  <p> Hello my name is Heli Kadakia. I am current undergraduate studnet at the University of California, Santa Cruz. Currently studying computer engineering and computer science, while also doing research in the department of Baskin Engineering.</p>
      //</div>

    
  //);
//}

export default function About() {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <h2>About Me</h2>

        <p>
          Hello my name is Heli Kadakia. Welcome to my website! I love creating, building, and learning. I am a third-year Computer Engineering major at the University of California, Santa Cruz (UCSC) with a strong passion in developing real world systems through software and engineering. I am particularly in interested in the correlation of software engineering through data driven systems. I love working on problems that require accuracy, structure, and well engineered designs. As a student I am motivated constantly by understanding how complex systems operate and work together to create a solution or how to improve them for well engineered solutions. Previously, I interned at a Kaiser Permanente Bacteriology Laboratory, where I worked in a high stakes clinical environment that emphasized precision, data integrity, and process reliability. This experience strengthened my attention to detail, ability to follow rigorous protocols, and appreciation for systems where correctness truly matters; skills that translate directly to writing dependable software.
        </p>

        <p>
        Currently, I work as a UX Designer for the UCSC Library, where I conduct user research, analyze workflows, and help design improvements to digital tools used by students and faculty. This role has strengthened my ability to translate real user pain points into practical design and engineering decisions, and to collaborate closely with stakeholders across technical and non-technical teams.
        </p>

        <p>
          In addition, I serve as a hackathon coach, mentoring student teams
          through ideation, development, and deployment under tight time
          constraints.
        </p>

        <p>
          Outside of academics and engineering, I enjoy staying active whether
          it’s going for a run or ice skating at 5am.
        </p>
      </div>
    </section>
  );
}
